module.exports = __webpack_public_path__ + "static/img_2.e17fd667.jpg";